import { Type, type Static } from "@sinclair/typebox";

export const GroupBuyFulfillmentRecordSchema = Type.Object(
  {
    id: Type.String({ minLength: 1 }),
    orderId: Type.String({ minLength: 1 }),
    sessionId: Type.String({ minLength: 1 }),
    tableId: Type.String({ minLength: 1 }),
    tableNumber: Type.String({ minLength: 1 }),
    businessDate: Type.String({ pattern: "^\\d{4}-\\d{2}-\\d{2}$" }),
    channelSnapshot: Type.Object(
      {
        id: Type.String({ minLength: 1 }),
        provider: Type.Union([Type.Literal("MEITUAN"), Type.Literal("DOUYIN")]),
        displayName: Type.String({ minLength: 1 }),
        version: Type.Integer({ minimum: 1 }),
        fulfillmentMode: Type.Literal("MANUAL_PLATFORM_APP"),
        officialIntegration: Type.Literal("NOT_VERIFIED"),
      },
      { additionalProperties: false },
    ),
    packageSnapshot: Type.Object(
      {
        id: Type.String({ minLength: 1 }),
        name: Type.String({ minLength: 1 }),
        version: Type.Integer({ minimum: 1 }),
        includedMinutes: Type.Integer({ minimum: 0, maximum: 1_440 }),
        components: Type.Array(
          Type.Object(
            {
              kind: Type.Union([Type.Literal("PRODUCT"), Type.Literal("SERVICE")]),
              referenceId: Type.Union([Type.String({ minLength: 1 }), Type.Null()]),
              name: Type.String({ minLength: 1 }),
              quantity: Type.Integer({ minimum: 1, maximum: 99 }),
            },
            { additionalProperties: false },
          ),
          { maxItems: 30 },
        ),
      },
      { additionalProperties: false },
    ),
    platformReference: Type.String({ minLength: 4, maxLength: 64 }),
    voucherCoveredFen: Type.Integer({ minimum: 0 }),
    customerSupplementFen: Type.Integer({ minimum: 0 }),
    expectedSettlementFen: Type.Integer({ minimum: 0 }),
    expectedFeeFen: Type.Integer({ minimum: 0 }),
    expectedSubsidyFen: Type.Integer({ minimum: 0 }),
    actualSettlementFen: Type.Union([Type.Integer({ minimum: 0 }), Type.Null()]),
    actualFeeFen: Type.Union([Type.Integer({ minimum: 0 }), Type.Null()]),
    actualSubsidyFen: Type.Union([Type.Integer({ minimum: 0 }), Type.Null()]),
    reconciliationOutcome: Type.Union([
      Type.Literal("PENDING"),
      Type.Literal("CONFIRMED"),
      Type.Literal("NOT_SETTLED"),
      Type.Literal("AMOUNT_MISMATCH"),
      Type.Literal("DUPLICATE_RECORD"),
    ]),
    note: Type.String({ maxLength: 200 }),
    reconciliationNote: Type.Union([Type.String({ maxLength: 500 }), Type.Null()]),
    coverageStartedAt: Type.String({ format: "date-time" }),
    coverageEndsAt: Type.String({ format: "date-time" }),
    fulfilledAt: Type.String({ format: "date-time" }),
    reconciledAt: Type.Union([Type.String({ format: "date-time" }), Type.Null()]),
    actorId: Type.String({ minLength: 1 }),
    authorizerId: Type.Union([Type.String({ minLength: 1 }), Type.Null()]),
    evidence: Type.Literal("MANUAL_FALLBACK"),
  },
  { additionalProperties: false },
);

export type GroupBuyFulfillmentRecordContract = Static<typeof GroupBuyFulfillmentRecordSchema>;
